import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}technician`;

const deleteTechnicianCommand = async ({
  technicianId,
}: {
  technicianId: string;
}): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    const response = await apiCall<BaseBackResponse>(
      `${ENDPOINT}/${technicianId}`,
      {
        method: SUPPORTED_METHODS.DELETE,
      },
    );

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default deleteTechnicianCommand;
